import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import BaseAutoCompleteList from './base-autocomplete-list';

import * as BookerActions from '../../../../redux/actions/booking/booker-action-creators';
import KeyMap from '../../../../scripts/utilities/keymap';

const mapStateToProps = state => ({
  airportsList: state.Booker.airportsList,
  airportsListFiltered: state.Booker.airportsListFiltered,
  helperTraslatedCopy: state.LanguageBundle.helperTraslatedCopy,
  originAirport: state.Booker.originAirport,
});
class AutocompleteOrigin extends Component {
  constructor() {
    super();

    this.state = {
      isActive: null,
      searchTerm: null,
    };
  }

  render() {
    const {
      airportsList,
      dispatch,
      helperTraslatedCopy,
      originAirport,
      placeholderCopyID,
    } = this.props;

    const {
      isActive,
      searchTerm,
    } = this.state;

    const showClearButton = searchTerm && searchTerm.length > 0;

    const inputClasses = cx({
      'Autocomplete-input': true,
      'Autocomplete-input--transparent': !isActive /* !isActive && search */,
    });

    return (
      <div className='Autocomplete'>
        { Object.keys(originAirport).length > 0 &&
          <div className='Autocomplete-placeholderButton'>
            <span className='SelectedAirport-airportCity'>{ originAirport.city }</span>&nbsp;
            <span className='SelectedAirport-airportCode'>{ originAirport.code }</span>
          </div>
        }
        <input
          aria-label={ helperTraslatedCopy.getFormatMessageFromcopyId(placeholderCopyID) }
          className={ inputClasses }
          onBlur={ (e) => this.handleBlur(e) }
          onChange={ (e) => this.handleChange(e) }
          onFocus={ (e) => this.handleFocus(e) }
          placeholder={ Object.keys(originAirport).length > 0 ? null : helperTraslatedCopy.getFormatMessageFromcopyId('MYB_MENU_AIRPORTS_FAIL') }
          ref={ ref => this.inputOrigin = ref }
        />
        { isActive &&
          <BaseAutoCompleteList
            airportsList = { airportsList }
            dispatch= { dispatch }
            handleBlur = { (e) => this.handleBlur(e) }
            isActive = { isActive }
            searchTerm={ searchTerm }
            type = 'origin'
          />
        }
        { showClearButton ? this.renderClearButton() : null }
      </div>
    );
  }

  handleBlur = (e) => {
    if (e) {
      e.preventDefault();
      const { changeLabelOrigin } = this.props;

      e.target.value = '';

      changeLabelOrigin();

      this.setState({
        isActive: false,
        searchTerm: '',
      });
    }
  }

  handleChange = (e) => {
    this.setState({
      searchTerm: e.target.value,
    });
  }

  handleClearButtonEnter(e) {
    const { handleClear } = this.props;

    if (e.keyCode == KeyMap.ENTER || e.keyCode == KeyMap.RETURN ) {
      handleClear();

      document.activeElement.focus();
    }
  }

  handleClearClick(e) {
    e.preventDefault();
    e.target.value = '';

    this.setState({
      searchTerm: '',
    });

    this.inputOrigin.value = '';
    document.activeElement.focus();
  }

  handleFocus = (e) => {
    e.preventDefault();
    const { dispatch, changeLabelOrigin } = this.props;

    e.target.value = '';

    dispatch(BookerActions.changeDestinationAirport({}));

    changeLabelOrigin();

    this.setState({
      isActive: true,
    });
  }

  renderClearButton() {
    return (
      <button
        className='Booker-clearButton Icon Icon--xThin'
        onKeyUp={ (e) => this.handleClearButtonEnter(e) }
        onMouseDown={ (e) => this.handleClearClick(e) }
        type='button'
        value='clear' />
    );
  }
}

AutocompleteOrigin = connect(mapStateToProps)(AutocompleteOrigin);

export default AutocompleteOrigin;